import { Component, OnInit, AfterViewInit, ViewChild } from "@angular/core";
import { AuthService } from "../auth.service";
import { AppCommonService } from "../appcommon.service";
import { ActivatedRoute, Router } from '@angular/router';
import { IAccount } from "../headerandnavigation/accounts/account";
import { InvoicingService } from "./invoicing.service";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
import { Statement, StatementModel, StatementDocumentModel } from "./invoicing";
import { ApiEndPoints } from "../api.endpoints";
import { HeaderAndNavigationService } from "../headerandnavigation/headerandnavigation.service";
import { LoaderService } from "../LoaderService";

declare var $: any;

@Component({
  templateUrl: "./invoicingdetail.statements.component.html"
})
export class InvoicingDetailStatementsComponent implements OnInit, AfterViewInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;
  dtOptions: any = {};
  dtTrigger: Subject<any> = new Subject();
  public pageTitle: string = 'Invoicing';
  public invoiceName: string = 'statements';
  public activeAccountId: string = '';
  public accessAccounts: IAccount[];
  public processAccount: IAccount;
  public statementList: Statement[];
  constructor(
    private authService: AuthService,
    private appCommonService: AppCommonService,
    public invoicingService: InvoicingService,
    private route: ActivatedRoute,
    private router: Router,
    public headerAndNavigationService: HeaderAndNavigationService,
    public loaderService: LoaderService
  ) {
    this.appCommonService.pageContentAdditionalClass = "";
    this.appCommonService.pageName = this.pageTitle;
  }
  ngOnInit(): void {
    this.headerAndNavigationService.showhideNav(false, true);
    this.accessAccounts = this.authService.getSelectedAccessAccounts();
    this.processAccount = null;
    this.processAccount = this.accessAccounts[0];    
    this.statementsOnInit();
  }

  afterloaddata() {
    const self = this;
    $('#statementdatatable').DataTable({
      dom: '<"top"fipB<"clear">>rt<"bottom"ipB<"clear">>',
      responsive: true,
      info: false,
      iDisplayLength: 15,
      order: [],
      //columnDefs: [{ width: 32, targets: 0, visible: false }, { orderable: false, targets: [0, 3] }, { bSearchable: false, targets: [0, 3] }],
      columnDefs: [{ orderable: false, targets: [2] }, { bSearchable: false, targets: [2] }],
      fixedColumns: true,
      //buttons: [
      //  {
      //    extend: 'collection',
      //    text: 'Download <i class="fa fa-angle-down"></i>',
      //    buttons: [
      //      'excelHtml5',
      //      //'csvHtml5',
      //      'pdfHtml5']
      //  }
      //]

      buttons: [
        {
          extend: 'collection',
          text: 'Download <i class="fa fa-angle-down"></i>',
          buttons: [{
            extend: 'excelHtml5',
            title: 'statements',
            exportOptions: {
              columns: [0, 1],
              orthogonal: 'sort'
            },
            customizeData: function (data) {
              for (var i = 0; i < data.body.length; i++) {
                for (var j = 0; j < data.body[i].length; j++) {                  
                  data.body[i][j] = '\u200C' + data.body[i][j];
                }
              }
            }
          },
          {
            extend: 'pdfHtml5',
            title: 'statements',
            exportOptions: {
              columns: [0, 1]
            }
          }
          ]
        }
      ]
    });

    var table = $('#statementdatatable').DataTable();

    $('.dataTables_filter input', table.table().container())
      .off('.DT')
      .on('keyup.DT cut.DT paste.DT input.DT search.DT', function (e) {        
        if (this.value.length >= 1) {
          // Call the API search function
          table.search(this.value.replace(/\u200C/g, '')).draw();
        }

        // Ensure we clear the search if they backspace far enough
        if (this.value === "") {
          table.search("").draw();
        }
      });
  }
  statementsOnInit(): void {
    this.loaderService.display(true);
    this.dtOptions = {
      dom: '<"top"fipB<"clear">>rt<"bottom"ipB<"clear">>',
      responsive: true,
      info: false,
      iDisplayLength: 15,
      order: [],
      //columnDefs: [{ width: 32, targets: 0, visible: false }, { orderable: false, targets: [0, 3] }, { bSearchable: false, targets: [0, 3] }],
      columnDefs: [ { orderable: false, targets: [2] }, { bSearchable: false, targets: [2] }],
      fixedColumns: true,
      //buttons: [
      //  {
      //    extend: 'collection',
      //    text: 'Download <i class="fa fa-angle-down"></i>',
      //    buttons: [
      //      'excelHtml5',
      //      //'csvHtml5',
      //      'pdfHtml5']
      //  }
      //]

      buttons: [
        {
          extend: 'collection',
          text: 'Download <i class="fa fa-angle-down"></i>',          
          buttons: [{
            extend: 'excelHtml5',
            title: 'statements',
            exportOptions: {
              columns: [0, 1],
              orthogonal: 'sort'
            }
          },
          {
            extend: 'pdfHtml5',
            title: 'statements',
            exportOptions: {
              columns: [0, 1]
            }
          }
          ]
        }
      ]
    }
    this.loadStatementsList();
  }

  loadStatementsList() {
    var model: StatementModel = new StatementModel();
    model.AccountId = [];
    model.Token = this.authService.getToken().access_token;
    model.EndPointURL = ApiEndPoints.StatementsEndPoint;
    this.accessAccounts.forEach(item => {
      model.AccountId.push(item.id);
    });
    this.invoicingService.getStatements(model)
      .subscribe(
      (statements: Statement[]) => {
        this.statementList = statements;
        setTimeout(() => {
          this.afterloaddata();
          this.loaderService.display(false);
        }, 100);
        //this.dtTrigger.next();
        //this.loaderService.display(false);
      },
      (error: any) => {
        this.invoicingService.showError("Statements retrieval problem", <any>error)
      }
     );
  }

  DownloadStatementDocument(state: Statement) {    
    this.loaderService.display(true);
    var model: StatementDocumentModel = new StatementDocumentModel();
    var selectedAcc = this.accessAccounts.filter(x => x.name == state.accountNumber)[0];
    model.StatementId = state.id;
    model.AccountId = selectedAcc.id;
    model.Token = this.authService.getToken().access_token;
    model.EndPointURL = ApiEndPoints.StatementByIdEndPoint;
    this.invoicingService.getStatementDocument(model);
  }

  ngAfterViewInit(): void {

  }
}



// WEBPACK FOOTER //
// ./src/app/invoicing/invoicingdetail.statements.component.ts